<template>
	<div class="team-box">
		<van-image class="title" :src="titleImg" />
		<van-swipe class="swiper-item" ref="contactSwipe" @change="onChange">
			<van-swipe-item>
				<div class="mapBox" id="map-container"></div>
				<p class="tab-title"><strong>北京研发中心</strong></p>
				<p>地址：北京朝阳区望京科技创业园F座302室 401室</p>
				<p>邮编：100102</p>
				<p>电话：010-84148525</p>
				<p>传真：010-84148530</p>
			</van-swipe-item>
			<van-swipe-item>
				<div class="mapBox" id="map-container2"></div>
				<p class="tab-title"><strong>苏州市常熟总部工厂</strong></p>
				<p>地址：江苏省苏州市常熟经济技术开发区高新技术产业园盘锦北路9号</p>
				<p>邮编：215505</p>
				<p>电话：0512-52212600</p>
				<p>传真：0512-52212600</p>
			</van-swipe-item>
		</van-swipe>
		<van-icon class="arrow leftArrow" name="arrow-left" color="#545454" @click="Prev" />
		<van-icon class="arrow rightArrow" name="arrow" color="#545454" @click="Next" />
	</div>
</template>

<script>
export default {
	name: 'Contact',
	data() {
		return {
			current: 0,
			titleImg: require('../../../static/m/contact/title.png'),
			moreImg: require('../../../static/m/common/more2-dark.png')
		};
	},
	computed: {
		sliderIndex: function() {
			return this.current + 1;
		}
	},
	methods: {
		onChange(index) {
			this.current = index;
		},
		Prev() {
			this.$refs.contactSwipe.prev();
		},
		Next() {
			this.$refs.contactSwipe.next();
		},
		BaiduMap() {
			const map = new BMap.Map('map-container');
			var poi = new BMap.Point(116.480646, 40.017973);
			map.centerAndZoom(poi, 17);
			map.enableScrollWheelZoom();

			var content = '<div>' + '地址：北京朝阳区望京科技创业园F座302室 401室' + '</div>';
			var marker = new BMap.Marker(poi); //创建marker对象

			var searchInfoWindow = null;
			searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
				title: '金仕生物北京研发中心', //标题
				width: 150, //宽度
				height: 40, //高度
				offset: {
					width: 0,
					height: -10,
				},
				enableAutoPan: true, //自动平移
				searchTypes: [
					BMAPLIB_TAB_TO_HERE //到这里去
				]
			});
			marker.addEventListener('click', function(e) {
				searchInfoWindow.open(marker);
			});
			map.enableScrollWheelZoom();
			map.addOverlay(marker);
			
			
			const map2 = new BMap.Map('map-container2');
			var poi2 = new BMap.Point(120.724706, 31.718382);
			map2.centerAndZoom(poi2, 17);
			map2.enableScrollWheelZoom();
		
			var content2 = '<div>' + '地址：江苏省苏州市常熟经济技术开发区高新技术产业园盘锦北路9号' + '</div>';
			var marker2 = new BMap.Marker(poi2); //创建marker对象
		
			var searchInfoWindow2 = null;
			searchInfoWindow2 = new BMapLib.SearchInfoWindow(map2, content2, {
				title: '金仕生物苏州市常熟总部工厂', //标题
				width: 150, //宽度
				height: 40, //高度
				offset: {
					width: 0,
					height: -10,
				},
				enableAutoPan: true, //自动平移
				searchTypes: [
					BMAPLIB_TAB_TO_HERE //到这里去
				]
			});
			marker2.addEventListener('click', function(e) {
				searchInfoWindow2.open(marker2);
			});
			map2.enableScrollWheelZoom();
			map2.addOverlay(marker2);
		},
		loadSearchInfo() {
			// 添加SearchInfoWindow脚本
			const searchInfoWindowScript = document.createElement('script');
			searchInfoWindowScript.type = 'text/javascript';
			searchInfoWindowScript.src = '//api.map.baidu.com/library/SearchInfoWindow/1.5/src/SearchInfoWindow_min.js';
			document.head.appendChild(searchInfoWindowScript);

			// 添加SearchInfoWindow样式
			const searchInfoWindowStyle = document.createElement('link');
			searchInfoWindowStyle.rel = 'stylesheet';
			searchInfoWindowStyle.href = '//api.map.baidu.com/library/SearchInfoWindow/1.5/src/SearchInfoWindow_min.css';
			document.head.appendChild(searchInfoWindowStyle);

			// 使用Promise.all等待3个文件都加载完成
			Promise.all([
				new Promise((resolve, reject) => {
					searchInfoWindowScript.onload = resolve;
					searchInfoWindowScript.onerror = reject;
				}),
				new Promise((resolve, reject) => {
					searchInfoWindowStyle.onload = resolve;
					searchInfoWindowStyle.onerror = reject;
				})
			])
				.then(() => {
					// 所有文件都加载完成后触发回调函数
					console.log('所有文件加载完成！');
					this.BaiduMap();
				})
				.catch(error => {
					console.error('文件加载失败：', error);
				});
		}
	},
	created() {
		// 引入百度地图API，传入AK密钥
		const AK = 'jEuAGFs5wlT4AAEOaQgP2G9aArhG0xeG';

		// 添加百度地图API脚本
		const baiduMapApiScript = document.createElement('script');
		baiduMapApiScript.type = 'text/javascript';
		baiduMapApiScript.src = `//api.map.baidu.com/api?v=2.0&ak=${AK}&callback=initMap`;
		document.head.appendChild(baiduMapApiScript);

		window.initMap = () => {
			// API加载完成后自动调用该函数
			this.loadSearchInfo();
		};
	}
};
</script>

<style lang="less" scoped>
@import url('@/assets/css/index.less');
	@media only screen and (min-aspect-ratio: ~'486/814'){
		.swiper-item {
			top: 380/@r !important;
			font-size: 34/@r !important;
		}
	}
	.team-box {
		background-color: #e5e3e1;
		width: 100%;
		height: 100%;
	}
	.title {
		.scale(313,173);
		.pos-a(178,160,99);
	}
	.arrow {
		.scale(60,60);
		font-size: 60/@r;
		position: absolute;
		left:50%;top:50%;
		z-index: 99;
		transform: translate(-50%,-50%);
	}
	.leftArrow {
		margin-left: -500/@r;
	}
	.rightArrow {
		margin-left: 500/@r;
	}
	.swiper-item {
		width:826/@r;
		.pos-a-center(500);
		font-size:42/@r;
		color:#4d4d4d;
		p {
			margin:0;
		}
		.tab-title {
			font-weight:bold;
			margin:80/@r 0;
		}
	}
	.mapBox {
		.scale(826,650);
		overflow: hidden;
		/deep/.BMapLib_SearchInfoWindow {
			transform: scale(0.8);
			left:37px !important;
			transform-origin: center bottom;
			.BMapLib_trans {
				width: 58px;
			}
		}
		/deep/.BMap_Marker {
			.animation(fadeInNew, 0.6s)
		}
	}
	
	@keyframes fadeInNew{
		0%{
			opacity: 0.2;
		}
		100%{
			opacity: 1;
		}
	}
</style>
